import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { ACCOUNT_TYPE_BANK, ACCOUNT_TYPE_CREDIT_DEBIT_CARD } from 'common/financeConstants';
import { STRIPE_OBJECT_TYPE_TOKEN } from 'common/stripeConstants';
import { makeStripeCardExpirationString } from 'common/stripeHelpers';

import SrCard from 'client/components/SrCard/SrCard';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import UPStripeCardForm from 'client/components/UPConnectBankForm/UPStripeCardForm';
import UPStripeBankAccountForm from 'client/components/UPConnectBankForm/UPStripeBankAccountForm';

const UPConnectBankAccountFormStepConnect = ({ formikBag, formFields, onNext }) => {
  const { accountType } = formikBag.values;

  const _onStripeToken = useCallback(
    (token, formValues) => {
      formikBag.setFieldValue('stripeAccountToken', token.id);

      if (token.type === 'bank_account') {
        const nameParts = formValues.accountHolderName.split(' ');
        const firstName = nameParts.shift();
        const lastName = nameParts.join(' ');
        formikBag.setFieldValue('firstName', firstName);
        formikBag.setFieldValue('lastName', lastName || '');
        formikBag.setFieldValue('bankRoutingLast4', formValues.routingNumber.slice(-4));
        formikBag.setFieldValue('bankAccountLast4', formValues.accountNumber.slice(-4));
        formikBag.setFieldValue('cardExpiration', null);
        formikBag.setFieldValue('cardLast4', null);
      } else {
        formikBag.setFieldValue('bankRoutingLast4', null);
        formikBag.setFieldValue('bankAccountLast4', null);
        formikBag.setFieldValue('cardExpiration', makeStripeCardExpirationString(token.card));
        formikBag.setFieldValue('cardLast4', token.card.last4);
      }
      onNext();
    },
    [formikBag, onNext],
  );

  return (
    <SrCard>
      {formFields.map((formField, index) => (
        <SrFormikField
          formField={formField}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_ADOBE}
          margin={index === 0 ? '0 0 23px 0' : null}
          key={formField.id}
        />
      ))}
      {accountType === ACCOUNT_TYPE_BANK && (
        <UPStripeBankAccountForm onSubmit={_onStripeToken} buttonTitle="Next" />
      )}
      {accountType === ACCOUNT_TYPE_CREDIT_DEBIT_CARD && (
        <UPStripeCardForm
          objectType={STRIPE_OBJECT_TYPE_TOKEN}
          onSubmit={_onStripeToken}
          buttonTitle="Next"
        />
      )}
    </SrCard>
  );
};

UPConnectBankAccountFormStepConnect.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

UPConnectBankAccountFormStepConnect.displayName = 'UPConnectBankAccountFormStepConnect';

export default UPConnectBankAccountFormStepConnect;
